import React, { useEffect, useRef, useState } from 'react';

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button, CircularProgress, useTheme } from '@material-ui/core';

import API from 'utils/api';
import { useSources } from 'hooks';
import { call } from 'utils';
import { classes } from 'components/utils';
import { SectionTitle } from 'components';
import { compileResults, readQuestions } from './helpers';
import StopDialogContent from './StopDialogContent';

import styles from './StopScreenDialog.module.scss';

const StopScreenDialog = ({ interaction, onClose }) => {
  const [questions, setQuestions] = useState();
  const [busy, setBusy] = useState(false);

  const sources = useSources();
  const showOptions = useRef();
  const theme = useTheme();

  useEffect(() => {
    if (interaction) {
      setQuestions(readQuestions(interaction));
    } else {
      const timer = setTimeout(() => setQuestions(null), 500);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [interaction]);

  if (!questions) {
    return null;
  }

  if (interaction) {
    showOptions.current =
      interaction.type === 'prediction' || interaction.type === 'picks';
  }

  const onSubmit = async () => {
    try {
      setBusy(true);
      const res = compileResults(questions, showOptions.current);

      if (res.length) {
        await API.stopScreens(interaction._id, { questions: res }, sources);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setBusy(false);
      call(onClose);
    }
  };

  const renderTitle = () => {
    const highlight = { fontWeight: 'bold', color: theme.palette.primary.main };

    return (
      <div style={{ display: 'flex' }}>
        <SectionTitle title="Select screens to stop" iconPosition="top">
          Select a question and click <span style={highlight}>STOP SCREENS</span> button
          to stop showing it in the interaction from now on.
          {showOptions.current ? (
            <span>
              {' '}
              Optionally, select the correct answer to send that result to participating
              users.
            </span>
          ) : null}
        </SectionTitle>
      </div>
    );
  };

  return (
    <Dialog open={!!interaction}>
      <DialogTitle>{renderTitle()}</DialogTitle>

      <DialogContent className={classes(styles.content, busy ? styles.busy : '')}>
        <StopDialogContent
          questions={questions}
          showOptions={showOptions.current}
          onChange={() => setQuestions(state => [...state])}
        />

        <div className={styles.overlay}>
          <CircularProgress />
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          Cancel
        </Button>

        <Button
          onClick={onSubmit}
          variant="contained"
          color="primary"
          disabled={busy || !questions.find(it => it.checked && !it.stopped)}
        >
          Stop Screens
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StopScreenDialog;
